import { FormActions, FormBase } from './form-base';
import type { FormProps } from './types';

export function Form(props: FormProps) {
  return <FormBase {...props} />;
}

Form.Actions = FormActions;
